export enum EnumLanguages {
  "en" = "en",
  "nl" = "nl",
  "fr" =  "fr",
  "de" = "de",
  "es" = "es",
}